import {
  kategoriTindakanOptions,
  jenisAnestesiOptions,
  golonganTindakanOptions,
  ruangOperasiOptions
  } from "@/data/helper.js";
export let tabs = [
  { title: "data pemeriksaan", link: "pemeriksaan", active: true },
  { title: "data tindakan", link: "tindakan" },
  { title: "resep", link: "resep" }
];
export let data = {
  title: "Detail Operasi",
  backBtn: "/operasi",
  actionBtn: [

  ],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Detail Operasi", active: true }
  ]
};

export let longText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align a the freshlybrewed he clues and we joke. Pay why are expected return house. handed on align a the freshlybrewed he clues and we joke.";
export let veryLongText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align a the freshlybrewed he clues and we joke. Pay why are expected return house. handed on align a the freshlybrewed he clues and we joke.Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills. Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills";
export let mediumText =
  "Went poured wanted belt arm, rationally that him desk calculus all fall equally may has is heard hills, some the handed on align.";
export let detailTop = {
  picture: "https://randomuser.me/api/portraits/men/97.jpg",
  topSubtitle: "",
  title: "Ahmad Subekti",
  subtitle: "No RM : 12345 | Pasien Peserta BPJS",
  items: [
    { icon: "wc", content: "Laki-laki" },
    { icon: "phone", content: "0897-2020-9090" }
  ],
  topRight: [
    {
      key: 1,
      columns: [
        {
          colnum: 5,
          icon: "today",
          label: "TANGGAL LAHIR",
          content: "20 Des 1990 (30 th)"
        },
        {
          colnum: 7,
          icon: "apps",
          label: "PENANGGUNG JAWAB",
          content: "Rina Gunawan (Ibu)"
        }
      ]
    },
    {
      key: 1,
      columns: [
        { colnum: 5, icon: "wb_sunny", label: "AGAMA", content: "Islam" },
        {
          colnum: 7,
          icon: "place",
          label: "",
          content:
            "Jl. Bangau 7 no. 180, RT 003/009 Perumnas Depok I Kel. Depok Jaya, Kec. Pancoran Mas Depok, Jawa Barat"
        }
      ]
    }
  ]
};
import { costConstant } from './OperasiForm.js'
export let detailLeftTop = [
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      {
        label: "No. Registrasi   |    No. Rawat",
        content: "001  |   2020/04/16/000001",
        icon: "apps"
      },
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      { label: "Unit", content: "MAT | Poliklinik Mata", icon: "apps" },
      { label: "Jenis Periksa", content: "Kunjungan Pasien", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "Dokter yang Dituju",
        content: "D00000026  |   dr. Azizah Masthura",
        icon: "apps"
      }
    ]
  }
];

export let detailRightTop = [
  { label: "Metode Pembayaran", content: "BPJS", icon: "apps" },
  { label: "Nomor Peserta BPJS", content: "00000134786000", icon: "apps" },
  {
    label: "Asal Rujukan",
    content: "Rumah Sakit Mitra Keluarga Depok",
    icon: "apps"
  }
];

export let dataPetugasLeft = [
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      },
      {
        label: "Perawat Pemeriksa",
        content: "P00001  |  Anggriani Ginting",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "tanda vital", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "suhu badan", content: "37 C", icon: "apps" },
      { label: "tekanan darah", content: "120/80 mmHg", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "nadi", content: "75x/menit", icon: "apps" },
      { label: "respirasi", content: "60x/menit", icon: "apps" },
      { label: "gdse", content: "135mg/dL", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "skrining gizi", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      { label: "berat badan", content: "75 kg", icon: "apps" },
      { label: "tinggi badan", content: "180 cm", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 2,
    columns: [{ label: "fungsional", labelClass: "text-primary" }]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "alat bantu",
        content: "alat bantu jalan,alat bantu pendengaran",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      { label: "prothesa", content: "kaki palsu,gigi palsu", icon: "apps" }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [
      {
        label: "cacat tubuh",
        content: "cacat pada kaki bagian bawah,cacat pada gigi",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [{ label: "ADL", content: "Mandiri", icon: "apps" }]
  }
];
export let dataPetugasRight = [
  { label: "RPD", content: longText, icon: "" },
  { label: "STATUS ALERGI", labelClass: "text-primary" },
  { label: "Obat / Alkes", content: "Tidak memiliki alergi", icon: "apps" },
  { label: "Makanan", content: "Keju,Ikan,Udang,Telur Ayam", icon: "apps" },
  { label: "SKRINING RESIKO JATUH DAN CEDERA", labelClass: "text-primary" },
  {
    label:
      "a. Cara jalan pasien saat akan duduk di kursi  tampak tidak seimbang (sempoyongan/limbung)",
    content: "Ya",
    icon: "",
    labelClass: "text-lowercase text-info"
  },
  {
    label: "b. Pasien memegang pinggiran kursi/meja/benda lain saat akan duduk",
    content: "Ya",
    icon: "",
    labelClass: "text-lowercase text-info"
  },
  {
    label: "Hasil",
    content: "Resiko Tinggi ( Ditemukan a dan b )",
    icon: "apps"
  },
  { label: "Skala Nyeri", content: "4 dari 10 ( nyeri sedang )", icon: "apps" }
];
export let dataOphthalmic = [
  {
    key: String(Math.random(1023)),
    colnum: 3,
    columns: [
      {
        label: "Tanggal/Waktu Periksa",
        content: "16 April 2020 Jam 14:35",
        icon: "apps"
      },
      {
        label: "Perawat Pemeriksa",
        content: "P00001  |  Anggriani Ginting",
        icon: "apps"
      }
    ]
  },
  {
    key: String(Math.random(1023)),
    colnum: 1,
    columns: [{ label: "Keluhan Pasien", content: longText }]
  }
];
export let dataDokterLeft = [
  {
    label: "Tanggal/Waktu Periksa",
    content: "16 April 2020 Jam 14:35",
    icon: "apps"
  },
  { label: "Pemeriksaan Fisik", content: veryLongText }
];
export let dataDokterRight = [
  { label: "Dx Utama", content: mediumText },
  { label: "Dx Sekunder", content: mediumText },
  { label: "Penatalaksanaan Medis", content: mediumText }
];
export let subheader = {
  title: "Sub Employees",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "New Sub Employee",
      link: "#modalFormSubEmployee",
      iconLeft: "add",
      type: "modal"
    }
  ]
};
export let detailBottom = {
  subheader: subheader,
  tabs: [],
  sort: [],
  filters: []
};
export let detailApproval = {
  label: "Operasi Request Approval",
  readonly:true,placeholder: "Add notes about approval here",
  name: "approval_note",
  value: "",
  actionApprove: "/operasi/approve/1",
  labelApprove: "APPROVE CRUD",
  actionReject: "/operasi/reject/1",
  labelReject: "REJECT",
  approvedDays: { label: "Approved Days", name: "days_approved", value: 3 }
};

export let today=new Date();
import {getTime} from './helper.js';
export let time = getTime(today.getHours(), today.getMinutes());
//laporan
export let upperFormLeftLaporan = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal Operasi",
        type: "date",
        readonly:true,placeholder: "Pilih tanggal operasi",
        name: "tanggal",
        value: today,
        optional:true,
        additional: "",
        disabled:true,
        colwidth: "6"
      },
      {
        label: "Mulai Operasi",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_in",
        value: time,
        optional:true,
        additional: "",
        disabled:true,
        colwidth: "3"
      },
      {
        label: "Selesai Operasi",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_out",
        value: time,
        optional:true,
        additional: "",
        disabled:true,
        colwidth: "3"
      }
    ]
  }
];
export let upperFormLaporan = [
  {
    colnum: 5,
    columns: [
      {
        label: "Jam Mulai",
        type: "time",
        placeholder: "",
        name: "time_start",readonly:true,
        value: "",
        additional: "",
        colwidth: "2"
      },
      {
        label: "Jam Selesai",
        type: "time",
        placeholder: "",
        name: "time_end",readonly:true,
        value: "",
        additional: "",
        colwidth: "2"
      },
      {
        label: "Durasi Operasi",
        type: "addon-right",
        addon:"Menit",
        readonly:true,placeholder: "",
        name: "durasi",
        value: 0,
        mandatory: true,
        additional: "",
        colwidth: "2"
      },
      {
        label: "Ruang Operasi",
        type: "select",
        readonly:true,placeholder: "",
        name: "id_operasi_ruangan",
        value: 0,
        mandatory: true,
        additional: "",
        colwidth: "3",
        options: ruangOperasiOptions
      }
    ]
  }
];
export let leftFormLaporan = [
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Operator",
        type: "select",
        readonly:true,placeholder: "Pilih Dokter Operator",
        name: "id_dokter_operator",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Dokter Anestesi",
        type: "select",
        readonly:true,placeholder: "Pilih Dokter Anestesi",
        name: "id_dokter_anestesi",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Dokter Referal",
  //       type: "select",
  //       readonly:true,placeholder: "Pilih Dokter Referal",
  //       name: "id_dokter_referal",
  //       value: 0,
  //       mandatory: true,
  //       additional: "",
  //       options: []
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Instrumen",
        type: "select",
        readonly:true,placeholder: "Pilih Perawat Instrumen",
        name: "id_perawat_instrumen",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Anestesi",
        type: "select",
        readonly:true,placeholder: "Pilih Perawat Anestesi",
        name: "id_perawat_anestesi",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Perawat Sirkuler",
        type: "select",
        readonly:true,placeholder: "Perawat Sirkuler 1",
        name: "id_perawat_sirkuler_1",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        readonly:true,placeholder: "Perawat Sirkuler 2",
        name: "id_perawat_sirkuler_2",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        readonly:true,placeholder: "Perawat Sirkuler 3",
        name: "id_perawat_sirkuler_3",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        readonly:true,placeholder: "",
        name: "id_perawat_sirkuler_4",
        value: 0,
        optional:true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "select",
        readonly:true,placeholder: "",
        name: "id_perawat_sirkuler_5",
        value: 0,
        optional:true,
        additional: "",
        options: []
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Kategori Tindakan",
        type: "select",
        placeholder: "Pilih Kategori Tindakan",
        name: "kategori_tindakan",
        value: "",
        mandatory: true,
        multiple: false,
        options: kategoriTindakanOptions,readonly:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Golongan Tindakan",
        type: "select",
        placeholder: "Pilih Golongan Tindakan",
        name: "golongan_tindakan",
        value: "",
        mandatory: true,
        multiple: false,
        options: golonganTindakanOptions,readonly:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jenis Anestesi",
        type: "select",
        placeholder: "Pilih Jenis Anestesi",
        name: "jenis_anastesi",
        value: "",
        options: jenisAnestesiOptions,readonly:true,
        mandatory: true
      }
    ]
  }
];
export let rightFormLaporan = [
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa pra operasi",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        readonly:true,placeholder: "",
        name: "diagnosa_pra_operasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Diagnosa post operasi",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        readonly:true,placeholder: "",
        name: "diagnosa_post_operasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Komplikasi",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        readonly:true,placeholder: "",
        name: "komplikasi",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 3,
    columns: [
      {
        label: "Jumlah Pendarahan",
        type: "addon-right",
        addon: "cc",
        readonly:true,placeholder: "",
        name: "jumlah_pendarahan",
        value: "1",
        mandatory: true,
        additional: "",
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "jaringan_PA",
        type: "radio",readonly:true,
        label: "Jaringan PA",
        options: [
          {label:'Ya',value:"1"},
          {label:'Tidak',value:"0"}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Asal Jaringan",
        type: "text",
        readonly:true,placeholder: "",
        name: "asal_jaringan",
        value: "",
        mandatory: true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Implant",
        type: "textarea", regex: /^.{0,255}$/, regexError: "Melebihi batas maksimal (255 karakter)",
        placeholder: "max. 255 karakter",
        name: "implant",
        value: "",
        mandatory: true,readonly:true,
        additional: ""
      }
    ]
  },
];
// ceklis
export let upperFormCeklis = [
  {
    colnum: 3,
    columns: [
      {
        label: "Petugas",
        type: "select",
        readonly:true,placeholder: "Pilih Petugas",
        name: "id_petugas",
        value: 0,
        mandatory: true,
        additional: "",
        options: []
      }
    ]
  }
];
export let leftFormCeklis = [
  {
    colnum: 2,
    columns: [
      {
        label: "Sign in pukul",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_in",
        value: "",
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pasien sudah dikonfirmasi nama, prosedur,sisi/lokasi dan inform consent",
        type: "checkbox_old",readonly:true,single:true,
        header:"SEBELUM INDUKSI",
        name: "pre_induksi_konfirmasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Apakah sisi operasi sudah ditandai?",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_induksi_sisi_ditandai",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Upload Form Penandaan Lokasi Operasi",
        type: "file",readonly:true,
        name: "pre_induksi_file_penandaan",
        mandatory: false,
        optional:true,
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Apakah mesin Pulse oxymetri dan obat anestesi sudah dicek lengkap?",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_induksi_cek_oxymetri",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_alergi",
        type: "radio",readonly:true,
        label: "Apakah pasien mempunyai alergi?",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_kesulitan_bernapas",
        type: "radio",readonly:true,
        label: "Kesulitan bernafas/resiko aspirasi",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_induksi_resiko_darah",
        type: "radio_old",readonly:true,
        label: "Resiko kehilangan darah >500ml ( 7ml/kg pada anak )",
        mandatory:true,
        options: [
          {label:'Tidak',value:0},
          {label:'Ya, dan akses IV dan cairan sudah dipersiapkan',value:1}
        ]
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Tersedia produk darah",
        type: "text",
        readonly:true,placeholder: "",
        name: "pre_induksi_resiko_darah_ketersediaan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
];
export let middleFormCeklis = [
  {
    colnum: 2,
    columns: [
      {
        label: "Time out pukul",
        type: "time",
        readonly:true,placeholder: "",
        name: "time_out",
        value: null,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Semua anggota tim memperkenalkan diri dan perannya",
        type: "checkbox_old",readonly:true,single:true,
        header:"SEBELUM MULAI PEMBEDAHAN/IRIS",
        name: "pre_pembedahan_perkenalan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ya",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        label: "Dokter bedah, anestesi dan perawat mengkonfirmasi",
        type: "checkbox_old",readonly:true,single:true,
        class:'mb-0',
        name: "pre_pembedahan_konfirmasi_nama_pasien",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Nama Pasien",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_konfirmasi_prosedur",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Prosedur sisi operasi dan posisi yang direncanakan",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        name: "pre_pembedahan_foto",
        type: "radio",readonly:true,
        label: "Foto Rontgen/Imaging",
        mandatory: true,
        optional:false,
        options: [
          {label:'Ya',value:1},
          {label:'Tidak perlu dilakukan',value:0}
        ]
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        label: "Langkah Antisipasi kejadian kritis dokter bedah",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_antisipasi_prosedur_kritis",
        value: 0,
        class:'mb-0',
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Prosedur non rutin/kritis",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:'mb-0',
    columns: [
      {
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_antisipasi_durasi",
        value: 0,
        class:'mb-0',
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Lama/durasi operasi",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_antisipasi_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Antisipasi kehilangan darah",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Anestesi",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_anestesi_monitor",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pasien perlu perhatian khusus memerlukan alat monitoring khusus",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "",
        name: "pre_pembedahan_anestesi_monitor_keterangan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "Perawat",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_perawat_instrumen",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Instrument lengkap dan steril",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_perawat_instrumen_khusus",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Ada peralatan yang perlu perhatian khusus",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "",
        name: "pre_pembedahan_perawat_instrumen_khusus_keterangan",
        value: "",
        mandatory: false,
optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "Pencegahan Infeksi",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_pencegahan_antibiotik",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemberian antibiotik profilaksis",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_pencegahan_cukur_rambut",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Cukur rambut",
            value: 1
          },
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pembedahan_pencegahan_kontrol_gula",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Kontrol gula darah",
            value: 1
          },
        ],
      }
    ]
  }
];
export let rightFormCeklis = [
 {
    colnum: 2,
    columns: [
      {
        label: "Sign out pukul",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_out",
        value: null,
        additional: ""
      }
    ]
    },
    {
      colnum: 1,
      class:"mb-0",
      columns: [
        {
          label: "",
          type: "checkbox_old",readonly:true,single:true,
          header:"SEBELUM PASIEN MENINGGALKAN KAMAR OPERASI",
          name: "post_prosedur_dicatat",
          class:"mb-0",
          value: 0,
          mandatory: false,
          optional:true,
          multiple: false,
          options: [
            {
              label: "Nama prosedur harus dicatat",
              value: 1
            }
          ],
        }
      ]
    },
    {
      colnum: 1,
      class:"mb-0",
      columns: [
        {
          label: "",
          type: "checkbox_old",readonly:true,single:true,
          name: "post_kelengkapan_instrumen",
          class:"mb-0",
          value: 0,
          mandatory: false,
          optional:true,
          multiple: false,
          options: [
            {
              label: "Instrumen,kasa,jarum yang digunakan sudah dihitung dan lengkap",
              value: 1
            }
          ],
        }
      ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_diberi_label",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil operasi sudah diberi label dan benar",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    class:"mb-0",
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_masalah_peralatan",
        class:"mb-0",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Apakah ditemukan masalah pada peralatan yang perlu dilaporkan",
            value: 1
          }
        ],
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        readonly:true,placeholder: "",
        name: "post_masalah_peralatan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        header:"Semua anggota tim",
        label: "Apa yang diperlukan dan diperhatikan untuk pemulihan dan penanganan pasien?",
        type: "textarea",regex:/^.{0,255}$/,regexError:"Melebihi batas maksimal (255 karakter)",
        readonly:true,placeholder: "",
        name: "post_perhatian_pasien",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
];
// biaya
export let costForm = [
  {
    colnum: 1,
    columns: [
      {
        label: "Biaya Paket Operasi",
        type: "money",
        readonly:true,placeholder: "",
        name: "jenis_paket_operasi",
        value: 0,
        mandatory: true,
        disabled: true,
        additional:'diambil dari total biaya tindakan operasi'
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Dokter Operator",
        type: "money",
        readonly:true,placeholder: "",
        name: "jasa_dokter_operator",
        value: 0,
        mandatory: true
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Dokter Anestesi",
        type: "money",
        readonly:true,placeholder: "",
        name: "jasa_dokter_anestesi",
        value: 0,
        mandatory: true
      }
    ]
  },
  // {
  //   colnum: 1,
  //   columns: [
  //     {
  //       label: "Jasa Dokter Referal",
  //       type: "money",
  //       placeholder: "",
  //       readonly:true,name: "jasa_dokter_referal",
  //       value: 0,
  //       mandatory: true
  //     }
  //   ]
  // },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Perawat Anestesi",
        type: "money",
        placeholder: "",
        readonly:true,name: "jasa_perawat_anestesi",
        value: 0,
        mandatory: true
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Instrumentator",
        type: "money",
        readonly:true,placeholder: "",
        name: "jasa_instrumentator",
        value: 0,
        mandatory: true
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Jasa Perawat Sirkuler",
        type: "money",
        readonly:true,placeholder: "",
        name: "jasa_perawat_sirkuler",
        value: 0,
        mandatory: true,
        disabled: true,
        additional:`3 x ${costConstant.sirkuler_formatted}`
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Sewa Kamar Operasi",
        type: "money",
        readonly:true,placeholder: "",
        name: "sewa_kamar_operasi",
        value: 0,
        mandatory: true
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Pemberian obat dan alat kesehatan",
        type: "money",
        readonly:true,placeholder: "",
        name: "pemberian_obat_dan_alat_kesehatan",
        value: 0,
        mandatory: true,
        disabled: true,
        additional:"diambil dari total biaya obat dan alat kesehatan"
      }
    ]
  },
  {
    colnum: 1,
    columns: [
      {
        label: "Biaya lain-lain",
        type: "money",
        readonly:true,placeholder: "",
        name: "biaya_lain_lain",
        value: 0,
        mandatory: false,
        optional:true
      }
    ]
  }
];
// kondisi
export let upperFormKondisi = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal operasi",
        type: "date",
        readonly:true,placeholder: "",
        name: "tanggal",
        value: "",
        additional: ""
      },
      {
        label: "Mulai operasi pukul",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_in",
        value: "",
        additional: ""
      },
      {
        label: "Selesai operasi pukul",
        type: "time",
        readonly:true,placeholder: "",
        name: "sign_out",
        value: "",
        additional: ""
      }
    ]
  },
];
export let leftFormKondisi = [
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_daerah_operasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Daerah sekitar operasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_daerah_operasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_puasa",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Puasa",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_puasa_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_klisma",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Klisma",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_klisma_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_surat_izin",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Surat izin operasi dan anastesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_surat_izin_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_tanda_vital",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_tanda_vital_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_katheter",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang katheter",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_katheter_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_infus",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang infus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_infus_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_premedikasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Obat premedikasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_premedikasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_alergi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Alergi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_alergi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_perhiasan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Perhiasan dilepas",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_perhiasan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_make_up",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Make up, kutek di hapus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_make_up_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_aksesoris",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Gigi palsu, rambut palsu, lensa kontak, hearing",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_aksesoris_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_hasil_lab",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil lab/Radiologi EKG terlampir di status",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_hasil_lab_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_status",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Status lengkap",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_status_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_persediaan_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Persediaan darah/Go",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_persediaan_darah_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pilek_batuk",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pilek, batuk",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_pilek_batuk_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Darah lengkap",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_darah_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_pemeriksaan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemeriksaan BT,CT",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_pemeriksaan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_haid",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Haid",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_haid_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_konsul_anestesi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Konsul Anestesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_konsul_anestesi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "pre_acc_adm_kasir",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "ACC Adm/Kasir",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "pre_acc_adm_kasir_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
]
export let rightFormKondisi = [
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_infus",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang infus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_infus_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_ngt",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang NGT",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_ngt_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_drain",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang drain",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_drain_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tampon",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang tampon",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tampon_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_katheter",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang katheter",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_katheter_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_pemeriksaan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemeriksaan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_pemeriksaan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_laporan_pembedahan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Laporan pembedahan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_laporan_pembedahan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_instruksi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Instruksi post operasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_instruksi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_laporan_anestesi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Laporan Anestesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_laporan_anestesi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_resep",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Resep",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_resep_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_hasil_lab",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil Lab/Radiologi/EKG",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_hasil_lab_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_darah_sisa",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Darah sisa",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_darah_sisa_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_format_biaya",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Form biaya Adm",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_format_biaya_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_format_observasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Form Observasi Keperawatan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_format_observasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tanda_vital_td",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (TD)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tanda_vital_td_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tanda_vital_n",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (N)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tanda_vital_n_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tanda_vital_r",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital(R)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tanda_vital_r_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tanda_vital_s",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital(S)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tanda_vital_s_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",readonly:true,single:true,
        name: "post_tanda_vital_spo2",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (SpO2)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        readonly:true,placeholder: "keterangan",
        name: "post_tanda_vital_spo2_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  }
]

